// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1HVaR","modalForm":"UpgradeEpcsModal_modalForm__3j1v2","modalFooter":"UpgradeEpcsModal_modalFooter__1PM0O"};